import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function HeroSection() {
    const [currentWord, setCurrentWord] = useState(0);
    const [showFinal, setShowFinal] = useState(false);
    const [hasCompleted, setHasCompleted] = useState(false);

    const words = [
        '8 different tools',
        'scattered conversations',
        'lost documents',
        'messy billing',
    ];

    const resetAnimation = () => {
        setCurrentWord(0);
        setShowFinal(false);
        setHasCompleted(false);
    };

    useEffect(() => {
        if (showFinal) {
            setTimeout(() => setHasCompleted(true), 1000);
            return;
        }

        const interval = setInterval(() => {
            setCurrentWord((prev) => {
                if (prev === words.length - 1) {
                    setTimeout(() => setShowFinal(true), 2000);
                    return prev;
                }
                return prev + 1;
            });
        }, 2000);

        return () => clearInterval(interval);
    }, [showFinal]);

    return (
        <section
            className="relative overflow-hidden flex items-center justify-center bg-white 
              min-h-[60vh] md:min-h-[90vh]"

            style={{
                minHeight: '90vh',
                background: 'linear-gradient(135deg, #093A5B 0%, #0a4d6e 50%, #093A5B 100%)'
                // linear-gradient(to bottom,rgba(255,255,255,0.22) 0%,rgb(9,58,91) 15%,rgb(9,58,91) 100%)

            }}
        >
            {/* Background */}
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, transparent 1px)`,
                    backgroundSize: '50px 50px',
                }}
            />

            {/* Floating App Icons */}
            <FloatingIcons show={!showFinal} />

            {/* Content */}
            {/* <div className="relative z-10 text-center px-5 max-w-[900px] mx-auto">
                <AnimatePresence mode="wait">
                    {!showFinal ? (
                        <motion.div
                            key="problem"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="text-white mb-4 heroSection_Class"
                            // style={{ fontSize: '1.5rem', fontWeight: 500 }}
                            >
                                Your team is juggling
                            </div>

                            <div className="h-32 flex items-center justify-center heroSection_animation_Class">
                                <AnimatePresence mode="wait">
                                    <motion.h1
                                        key={currentWord}
                                        initial={{ opacity: 0, y: 20, filter: 'blur(10px)' }}
                                        animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
                                        exit={{ opacity: 0, y: -20, filter: 'blur(10px)' }}
                                        transition={{ duration: 0.5 }}
                                        className="text-white"
                                    >
                                        {words[currentWord]}
                                    </motion.h1>
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    ) : (
                        <motion.div
                            key="solution"
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                        >
                            <motion.h1
                                className="text-white mb-8 heroSection_Heading"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3, duration: 0.6 }}
                            >
                                What if there was<br />just one?
                            </motion.h1>

                            <motion.p
                                className="text-white mb-12 heroSection_Para
                                leading-relaxed font-normal"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.6, duration: 0.6 }}
                            >
                                Simplifyte brings everything—tasks, files, chat, billing—into one calm workspace.
                            </motion.p>

                            <motion.div
                                className='text-white'
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.9, duration: 0.6 }}
                            >
                                <MagneticButton>
                                    See How It Works
                                </MagneticButton>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div> */}
            <div className="relative z-10 text-center px-5 max-w-[900px] mx-auto">
                <AnimatePresence mode="wait">
                    {!showFinal ? (
                        <motion.div
                            key="problem"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            {/* Top line */}
                            <div className="text-white mb-4 heroSection_Class">
                                Your team is juggling
                            </div>

                            {/* Rotating words */}
                            <div className="h-32 flex items-center justify-center heroSection_animation_Class">
                                <AnimatePresence mode="wait">
                                    <motion.h1
                                        key={currentWord}
                                        initial={{ opacity: 0, y: 20, filter: "blur(10px)" }}
                                        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                        exit={{ opacity: 0, y: -20, filter: "blur(10px)" }}
                                        transition={{ duration: 0.5 }}
                                        className="text-white heroSection_Word"
                                    >
                                        {words[currentWord]}
                                    </motion.h1>
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    ) : (
                        <motion.div
                            key="solution"
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                        >
                            <motion.h1
                                className="text-white mb-8 heroSection_Heading"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3, duration: 0.6 }}
                            >
                                What if there was
                                <br />
                                just one?
                            </motion.h1>

                            <motion.p
                                className="text-white mb-12 heroSection_Para"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.6, duration: 0.6 }}
                            >
                                Simplifyte brings everything—tasks, files, chat, billing—into one calm
                                workspace.
                            </motion.p>

                            <motion.div
                                className="text-white"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.9, duration: 0.6 }}
                            >
                                <MagneticButton>See How It Works</MagneticButton>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>


            {/* Replay Button */}
            <AnimatePresence>
                {hasCompleted && (
                    <motion.button
                        className="absolute bottom-12 right-12 bg-black backdrop-blur-md text-white rounded-full p-2 md:p-4 flex items-center gap-3 group cursor-pointer border border-black"
                        style={{ fontSize: '0.9375rem', fontWeight: 500 }}
                        initial={{ opacity: 0, y: 20, scale: 0.8 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{ duration: 0.5 }}
                        whileHover={{
                            scale: 1.05,
                            backgroundColor: 'rgba(255, 255, 255, 0.15)',
                            borderColor: 'rgba(255, 255, 255, 0.4)',
                        }}
                        whileTap={{ scale: 0.95 }}
                        onClick={resetAnimation}
                    >
                        <motion.svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="group-hover:rotate-180 transition-transform duration-500"
                        >
                            <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                        </motion.svg>
                        <span className="pr-2">Replay Story</span>
                    </motion.button>
                )}
            </AnimatePresence>
        </section>
    );
}
const isMobile = window.innerWidth < 768;

function FloatingIcons({ show }) {
    const icons = [
        { emoji: '📧', x: -30, y: -20 },
        { emoji: '💬', x: 30, y: -30 },
        { emoji: '📊', x: -35, y: 10 },
        { emoji: '💼', x: 35, y: 15 },
        { emoji: '📁', x: -25, y: 35 },
        { emoji: '📅', x: 25, y: 30 },
        { emoji: '📝', x: -40, y: -5 },
        { emoji: '💳', x: 40, y: 0 },
    ];

    return (
        <div className="absolute inset-0 pointer-events-none animation_class">
            {icons.map((icon, idx) => (
                <motion.div
                    key={idx}
                    className="absolute left-1/2 top-1/2 animation_inner_class text-5xl sm:text-4xl"
                    initial={{ x: 0, y: 0, opacity: 0, scale: 0 }}
                    animate={
                        show
                            ? {
                                x: isMobile ? `${icon.x / 2.5}vw` : `${icon.x}vw`,
                                y: isMobile ? `${icon.y / 5}vh` : `${icon.y}vh`,
                                opacity: 0.6,
                                scale: isMobile ? 0.7 : 1,
                            }
                            : { x: 0, y: 0, opacity: 0, scale: 0 }
                    }
                    transition={{
                        duration: 0.8,
                        delay: idx * 0.1,
                    }}

                >
                    {icon.emoji}
                </motion.div>
            ))}
        </div>
    );
}

function MagneticButton({ children }) {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        setPosition({ x: x * 0.3, y: y * 0.3 });
    };

    const handleMouseLeave = () => {
        setPosition({ x: 0, y: 0 });
        setIsHovered(false);
    };

    return (
        <motion.button
            className="bg-blue-500 text-[--color-primary] relative overflow-hidden text-sm sm:text-base md:text-lg px-4 py-4 sm:px-7 sm:py-7 rounded-full"
            // style={{
            //     fontSize: '1.125rem',
            //     fontWeight: 600,
            //     padding: '16px 48px',
            //     borderRadius: '50px',
            // }}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={handleMouseLeave}
            animate={{ x: position.x, y: position.y, scale: isHovered ? 1.05 : 1 }}
            transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        >
            <motion.div
                className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent"
                animate={{ x: ['-100%', '200%'] }}
                transition={{ duration: 3, repeat: Infinity, repeatDelay: 2 }}
                style={{ width: '50%' }}
            />
            <span className="relative z-10">{children}</span>
        </motion.button>
    );
}
